var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"display-flex"},[_c('div',{staticClass:"pr-2"},[_c('SIcon',{attrs:{"name":"tool-play"}})],1),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-centerize"},[_c('h1',{staticClass:"med"},[_vm._v("New Portal")])])
}]

export { render, staticRenderFns }